import { FormControl, Grid, IconButton, InputLabel, Select, TextField
    , Typography, Stack, Box, Checkbox, FormControlLabel, Table, TableBody
    , TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip
    , Card, CardContent, Button, Snackbar, Alert } from '@mui/material';
import { Search as IconSearch, AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../services/api";
import moment from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setEntity, setData, setValidationMessage, activeValidations
    , setListTiposTerapias, setListCategorias, setListEstadosApertura, setListEstados
    , setListPeriodicidades, setDiasLaborables, setListPeriodoDetalle } from "../redux/periodSlice";
import { FormHelperText as HelperText } from '@mui/material';

const Period = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const entity = useSelector((state) => state.period.entity);
    const defaultEntity = useSelector((state) => state.period.defaultEntity);
    const listTiposTerapias = useSelector((state) => state.period.listTiposTerapias);
    const listCategorias= useSelector((state) => state.period.listCategorias);
    const listEstadosApertura= useSelector((state) => state.period.listEstadosApertura);
    const listEstados = useSelector((state) => state.period.listEstados);
    const listPeriodicidades = useSelector((state) => state.period.listPeriodicidades);
    const listPeriodoDetalle = useSelector((state) => state.period.listPeriodoDetalle);
    const validate = useSelector((state) => state.period.validationActive);
    const dispatch = useDispatch();
    const [openFeeSearch, setOpenFeeSearch] = useState(false);
    // Cuenta los dias laborables entre las dos fechas. Se consulta al API, que es
    // donde esta la regla de los feriados.
    const [diasLaborables, setDiasLaborablesLocal] = useState(entity.diasLaborables || 0);
    const fechaIngresoMinimo = new Date(2010, 1, 1);
    // Categoria Academico (catalogo 67). El detalle solo referencia
    // periodos Academicos.
    const CATEGORIA_ACADEMICO = 67;
    // Periodicidades en las que el codigo se escribe a mano: Semanal (301) y
    // Quincenal (302). El API no las genera.
    const PERIODICIDAD_MANUAL = [301, 302];
    const esCodigoManual = () => PERIODICIDAD_MANUAL.includes(parseInt(entity.idPeriodicidad));
    // Lista de periodos Academicos disponibles para referenciar.
    const [listPeriodosAcademicos, setListPeriodosAcademicos] = useState([]);
    // Academicos que ya estan en el detalle de otro periodo de Planificacion.
    const [periodosRepetidos, setPeriodosRepetidos] = useState([]);

    var validation = {
        // El periodo no tiene filial: es comun a todas las sedes.
        idTipoTerapia: {
            error: entity.idTipoTerapia == 0 || entity.idTipoTerapia == null,
            message: "Falta ingresar el tipo de terapia",
        },
        codigo: {
            // Con "Generar Codigo" marcado el codigo lo arma el API al guardar,
            // asi que el campo no es obligatorio. En semanal y quincenal el
            // codigo siempre se escribe a mano.
            error: (esCodigoManual() || !entity.generarCodigo) && (entity.codigo || "").length < 1,
            message: "Falta ingresar el codigo del periodo",
        },
        fechaInicio: {
            error: Date.parse(entity.fechaInicio) < fechaIngresoMinimo,
            message: "Debe ser una fecha mayor al " + fechaIngresoMinimo.getFullYear(),
        },
        fechaFin: {
            error: Date.parse(entity.fechaFin) < Date.parse(entity.fechaInicio),
            message: "La fecha fin no puede ser anterior a la fecha inicio",
        },
    }
    const openCloseFeeSearch = () => { setOpenFeeSearch(!openFeeSearch); }
    // El contenedor incrementa esta llave despues de guardar para que la pantalla
    // vuelva a traer el periodo del API. Hace falta porque el codigo lo arma el API
    // al guardar: sin recargar, el campo Codigo seguia vacio y parecia que no se
    // habia generado.
    const refreshKey = props.refreshKey || 0;
    // Al guardar un periodo nuevo la pantalla pasa a /period/edit/<id>. El id se
    // lee de aqui para que fetchEntity use el vigente y no el del primer render.
    const idActual = useRef(params.id);
    // Id del periodo que se esta mostrando, para detectar el cambio al navegar.
    const periodoMontadoRef = useRef(params.id);
    idActual.current = params.id;
    // La entidad vigente, para que el calculo del codigo no se quede con los
    // valores de un render anterior.
    const entidadActual = useRef(entity);
    entidadActual.current = entity;

    const fetchEntity = useCallback(async () => {
        const response = await api.get("/Periodo/GetPeriodoView?idPeriodo=" + idActual.current)
            .catch((err) => {
                console.log("Err: ", err);
                return { data: {} };
            });

        if (response.data?.data == null || response.data?.data.length == 0){
            dispatch(setEntity(defaultEntity));
            recalculaFechas(defaultEntity.idPeriodicidad, moment(defaultEntity.fechaInicio).format('yyyy-MM-DD'));
        }
        else {
            response.data.data.generarCodigo = false;
            dispatch(setEntity(response.data.data));

            // Los dias laborables del periodo se muestran al abrirlo.
            setDiasLaborablesLocal(response.data?.data?.diasLaborables || 0);
        }
    }, [])
    const fetchListTiposTerapias = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=49")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListTiposTerapias(response?.data?.data || []));
    }, [])
    const fetchListCategorias = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=66")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListCategorias(response?.data?.data || []));
    }, [])
    const fetchListEstadosApertura = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=86")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListEstadosApertura(response?.data?.data || []));
    }, [])
    const fetchListEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListEstados(response?.data?.data || []));
    }, [])
    const fetchListPeriodicidades = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=300")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListPeriodicidades(response?.data?.data || []));
    }, [])
    // Detalle del periodo: trae los periodos Academicos que
    // ya estan referenciados en este periodo.
    const fetchListPeriodoDetalle = useCallback(async () => {
        const idPeriodo = parseInt(idActual.current || "0");

        // En un periodo nuevo no hay detalle en la base: lo que haya en la
        // pantalla es el que se ira a guardar con el periodo, asi que no se
        // toca.
        if (idPeriodo <= 0) {
            return;
        }

        const response = await api.get("/Periodo/GetsPeriodoDetalleView?idPeriodo=" + idPeriodo)
            .catch((err) => {
                console.log("Err: ", err)
            });

        dispatch(setListPeriodoDetalle(response?.data?.data || []));
    }, [params.id])
    // Academicos que ya estan en el detalle de otro periodo de Planificacion:
    // no se ofrecen en el selector porque un Academico pertenece como maximo a
    // un periodo de Planificacion.
    const fetchPeriodosRepetidos = useCallback(async () => {
        const idPeriodo = parseInt(idActual.current || "0");

        const response = await api.get("/Periodo/GetsPeriodoDetalleRefRepetidos?idPeriodo=" + idPeriodo)
            .catch((err) => {
                console.log("Err: ", err)
                return { data: { data: [] } }
            });

        setPeriodosRepetidos(response?.data?.data || []);
    }, [])

    // Periodos Academicos disponibles para referenciar en el
    // detalle (categoria 67 = Academico).
    const fetchListPeriodosAcademicos = useCallback(async () => {
        const response = await api.get('/Periodo/GetsPeriodoView?'
        + 'idTipoTerapia=0'
        + '&idEstadoApertura=87'
        + '&mesesHaciaAtras=0'
        + '&idEstado=2'
        + '&idCategoria=' + CATEGORIA_ACADEMICO
        )
        .then((response) => {
            setListPeriodosAcademicos(response?.data?.data || []);
        })
        .catch((err) => {
            console.log("Err: ", err)
        });
    }, [])

    // La fecha fin sale de la periodicidad y la fecha inicio, y los dias
    // laborables de las dos fechas. El API es quien tiene la regla.
    const recalculaDiasLaborables = useCallback(async (fechaInicio, fechaFin) => {
        if (!fechaInicio || !fechaFin) return;

        const dias = await api.get("/DiaFeriado/GetsDiasLaborables?fechaInicio=" + fechaInicio
                + "&fechaFin=" + fechaFin)
            .catch((err) => { console.log("Err: ", err) });

        if (dias && dias.data) {
            setDiasLaborablesLocal(dias.data.data);
            dispatch(setDiasLaborables(dias.data.data));
        }
    }, [])

    const recalculaFechas = useCallback(async (idPeriodicidad, fechaInicio) => {
        if (!fechaInicio) return;

        const fin = await api.get("/DiaFeriado/GetFechaFinPorPeriodicidad?idPeriodicidad=" + idPeriodicidad
                + "&fechaInicio=" + fechaInicio)
            .catch((err) => { console.log("Err: ", err) });

        if (fin && fin.data && fin.data.data) {
            const fechaFin = moment(fin.data.data).format('yyyy-MM-DD');

            dispatch(setData({name: "fechaFin", value: fechaFin}));

            recalculaDiasLaborables(fechaInicio, fechaFin);
        }
    }, [])

    // Codigo que le tocaria al periodo con lo que hay en la pantalla. Se le pide
    // al API para que la regla este en un solo lado y se pueda mostrar mientras se
    // registra, no solo despues de guardar.
    //
    // El numero de peticion evita que una respuesta lenta de una combinacion
    // anterior pise el codigo de la combinacion que esta en pantalla ahora.
    const peticionCodigo = useRef(0);
    const recalculaCodigo = useCallback(async () => {
        if (!entidadActual.current.generarCodigo) return;

        const idTipoTerapia = parseInt(entidadActual.current.idTipoTerapia);
        const idPeriodicidad = parseInt(entidadActual.current.idPeriodicidad);
        const fechaInicio = entidadActual.current.fechaInicio;
        const fechaFin = entidadActual.current.fechaFin;

        if (!(idTipoTerapia > 0) || !(idPeriodicidad > 0) || !fechaInicio) return;
        if (PERIODICIDAD_MANUAL.includes(idPeriodicidad)) return;

        const numero = peticionCodigo.current + 1;

        peticionCodigo.current = numero;

        const codigo = await api.get("/Periodo/GetsCodigoPeriodo?"
            + "idTipoTerapia=" + idTipoTerapia
            + "&idPeriodicidad=" + idPeriodicidad
            + "&fechaInicio=" + fechaInicio
            + "&fechaFin=" + (fechaFin || fechaInicio))
            .catch((err) => { console.log("Err: ", err) });

        if (numero !== peticionCodigo.current) return;
        if (codigo && codigo.data && codigo.data.data != null) {
            dispatch(setData({name: "codigo", value: codigo.data.data}));
        }
    }, [])

    useEffect(() => {
        fetchEntity();
        fetchListTiposTerapias();
        fetchListCategorias();
        fetchListEstadosApertura();
        fetchListEstados();
        fetchListPeriodicidades();
        fetchListPeriodoDetalle();
        fetchListPeriodosAcademicos();
        fetchPeriodosRepetidos();
        dispatch(setValidationMessage(messagesValidation()));
    }, []);

    // Al cambiar de periodo (por ejemplo, tras guardar uno nuevo, que pasa a
    // /period/edit/<id>) el detalle se reinicia: lo que habia en pantalla eran
    // pendientes del alta y ya viene guardado desde el API.
    useEffect(() => {
        if (periodoMontadoRef.current === params.id) return;

        periodoMontadoRef.current = params.id;
        dispatch(setListPeriodoDetalle([]));
        fetchListPeriodoDetalle();
        fetchPeriodosRepetidos();
    }, [params.id, fetchListPeriodoDetalle, fetchPeriodosRepetidos])

    useEffect(() => {
        dispatch(setValidationMessage(messagesValidation()));
    }, [entity])

    // Mientras se registra, con el check Generar Codigo activo, el codigo se va
    // mostrando solo. Solo en el alta: en un periodo ya guardado manda el que
    // tiene guardado.
    //
    // Reacciona a la fecha fin y no a la periodicidad ni a la fecha inicio
    // porque la fecha fin la recalcula el API despues: si se reaccionara a esas,
    // se armaria un codigo con la fecha fin de la periodicidad anterior y se
    // veria un codigo equivocado antes del correcto.
    useEffect(() => {
        if (!entity.generarCodigo) return;
        if (parseInt(entity.id) > 0) return;

        recalculaCodigo();
    }, [entity.idTipoTerapia, entity.fechaFin, entity.generarCodigo, entity.id]);

    // Despues de guardar, el contenedor avisa con la llave para recargar el
    // periodo ya guardado, que es donde quedo el codigo que genero el API.
    useEffect(() => {
        if (refreshKey > 0) {
            fetchEntity();
            fetchListPeriodoDetalle();
        }
    }, [refreshKey]);

    var setDataEntity = e => {
        dispatch(setData(e.target));
    }
    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }
    // El codigo del periodo lo arma el API con el tipo de terapia, la
    // periodicidad y las fechas (ver PeriodoService.GenerarCodigoPeriodo).
    // Aqui no se calcula para que la web y el API no hagan reglas distintas.

    // Agrega un periodo Academico al detalle del periodo.
    //
    // Con el periodo ya guardado se manda al API, que valida que el Academico
    // no este en el detalle de otro periodo de Planificacion y devuelve la
    // lista. En un periodo NUEVO todavia no hay id: el Academico queda
    // pendiente en la pantalla y se manda con el periodo al_guardar, para no
    // obligar a guardar dos veces.
    const agregarPeriodoDetalle = async (idPeriodoDetalleRef) => {
        const idPeriodo = parseInt(params.id || "0");
        const ref = parseInt(idPeriodoDetalleRef || "0");

        if (ref <= 0) {
            return;
        }

        const academico = (listPeriodosAcademicos || []).find((x) => x.id === ref);
        const pendiente = {
            id: 0,
            idPeriodo: 0,
            idPeriodoDetalleRef: ref,
            codigoPeriodoDetalle: academico == null ? "" : (academico.codigo || ""),
            fechaInicioPeriodoDetalle: academico == null ? null : academico.fechaInicio,
            fechaFinPeriodoDetalle: academico == null ? null : academico.fechaFin,
        };

        if (idPeriodo <= 0) {
            dispatch(setListPeriodoDetalle((listPeriodoDetalle || []).concat([pendiente])));
            return;
        }

        let error = null;

        const response = await api.post("/Periodo/PostPeriodoDetalle", {
            idPeriodo: idPeriodo,
            idPeriodoDetalleRef: ref,
            observaciones: "",
        }).catch((err) => {
            console.log("Err: ", err);
            error = err;
        });

        // Un Academico no puede estar en el detalle de dos periodos de
        // Planificacion: el API lo rechaza y se avisa con el motivo.
        if (error) {
            const detalle = (error.response && error.response.data && error.response.data.detail)
                ? error.response.data.detail
                : "No se pudo agregar el periodo Academico al detalle.";
            setMensaje(detalle);
            return;
        }

        if (response && response.data) {
            fetchListPeriodoDetalle();
        }
    }

    // Quita un periodo Academico del detalle del periodo. Un Academico que
    // todavia no se guardo (periodo nuevo) solo se quita de la lista pendiente.
    const quitarPeriodoDetalle = async (idPeriodoDetalle) => {
        const id = parseInt(idPeriodoDetalle || "0");

        if (id <= 0) {
            dispatch(setListPeriodoDetalle((listPeriodoDetalle || [])
                .filter((row) => row.id !== id)));
            return;
        }

        const response = await api.post("/Periodo/DeletePeriodoDetalle?idPeriodoDetalle=" + id)
            .catch((err) => {
                console.log("Err: ", err);
            });

        if (response && response.data) {
            fetchListPeriodoDetalle();
        }
    }

    // Periodos Academicos que ya estan en el detalle, para no
    // mostrarlos otra vez en el selector.
    // Academicos que ya se offering: los del propio detalle y los que estan en
    // el detalle de otro periodo de Planificacion.
    // Aviso cuando el API rechaza un Academico que ya esta en otro periodo de
    // Planificacion.
    const [mensaje, setMensaje] = useState(null);
    const cerrarMensaje = () => setMensaje(null);

    const periodosEnDetalle = (listPeriodoDetalle || []).map(
        (row) => row.idPeriodoDetalleRef
    ).concat(periodosRepetidos || []).map((x) => parseInt(x));
    // Id del periodo abierto. El detalle solo se puede editar cuando el
    // periodo ya esta guardado.
    const idPeriodoActual = parseInt(params.id || "0");
    // Periodo Academico elegido en el selector, pendiente de agregar.
    const [periodoDetalleElegido, setPeriodoDetalleElegido] = useState(0);

    return (
        <>
        <Grid container>
            {/* {JSON.stringify(validation)}
            {JSON.stringify(validate)} */}
            {/* {JSON.stringify(entity)} */}
            <Grid item>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Datos Basicos
                    </Typography>
                </Box>
            </Grid>
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth error={validate.idTipoTerapia && validation.idTipoTerapia.error}>
                        <InputLabel htmlFor="input-tipoterapia">Tipo Terapia</InputLabel>
                        <Select
                            native
                            label="Tipo Terapia"
                            value={entity.idTipoTerapia}
                            onChange={(event) => {
                                var id = event.nativeEvent.target.selectedIndex;
                                
                                dispatch(setData({name: "idTipoTerapia", value: event.target.value}))
                                dispatch(setData({name: "tipoTerapia", value: event.nativeEvent.target[id].text}))
                            }}
                            inputProps={{
                                name: 'idTipoTerapia',
                                id: 'input-tipoterapia',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listTiposTerapias.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        <HelperText>
                            {validate.idTipoTerapia && validation.idTipoTerapia.error ? validation.idTipoTerapia.message : ""}
                        </HelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="codigo"
                        label="Codigo"
                        fullWidth
                        value={entity.codigo || ""}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                        // Con "Generar Codigo" marcado lo arma el API. En semanal y
                        // quincenal el codigo siempre es manual.
                        required={esCodigoManual() || !entity.generarCodigo}
                        size="small"
                        // Sin shrink la etiqueta queda dentro del campo y se
                        // superpone con el codigo ya escrito.
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControlLabel control={
                        <Checkbox
                            name="generarCodigo"
                            checked={entity.generarCodigo && !esCodigoManual()}
                            onChange={(event, newValue) => {
                                dispatch(setData({name: "generarCodigo", value: event.target.checked}))

                                // Al marcarlo se limpia el codigo: asi lo arma
                                // el API al guardar. Si se desmarca, el campo
                                // queda para escribirlo a mano.
                                if (event.target.checked){
                                    dispatch(setData({name: "codigo", value: ""}))
                                }
                            }}
                            // En semanal y quincenal el API no arma el codigo.
                            disabled={isReadOnly || esCodigoManual()}
                            size='small'
                        />
                        } label={esCodigoManual() ? "Codigo manual" : "Generar Codigo"} />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="fechaInicio"
                        label="Fecha Inicio"
                        fullWidth
                        type="date"
                        //defaultValue={moment()}
                        value={moment(entity.fechaInicio).format('yyyy-MM-DD')}
                        onChange={(event) => {
                            dispatch(setData({name: "fechaInicio", value: event.target.value}))

                            // La fecha fin depende de la periodicidad elegida.
                            recalculaFechas(entity.idPeriodicidad, event.target.value)
                        }}
                        error={validate.fechaInicio && validation.fechaInicio.error}
                        helperText={validate.fechaInicio && validation.fechaInicio.error ? validation.fechaInicio.message : ""}
                        disabled={isReadOnly}
                            size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-periodicidad">Periodicidad</InputLabel>
                        <Select
                            native
                            label="Periodicidad"
                            value={entity.idPeriodicidad}
                            onChange={(event) => {
                                const idPeriodicidad = parseInt(event.target.value);

                                dispatch(setData({name: "idPeriodicidad", value: idPeriodicidad}))

                                const periodicidad = listPeriodicidades?.find((row) => row.id == idPeriodicidad);

                                if (periodicidad) {
                                    dispatch(setData({name: "periodicidad", value: periodicidad.descripcion}))
                                }

                                // Cambiar la periodicidad recalcula la fecha fin.
                                recalculaFechas(idPeriodicidad, moment(entity.fechaInicio).format('yyyy-MM-DD'))

                                // En semanal y quincenal el codigo se escribe a mano,
                                // asi se limpia el que habia para que no quede uno de
                                // otra periodicidad pegado.
                                if (PERIODICIDAD_MANUAL.includes(idPeriodicidad)) {
                                    dispatch(setData({name: "codigo", value: ""}))
                                }
                            }}
                            inputProps={{
                                name: 'idPeriodicidad',
                                id: 'input-periodicidad',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listPeriodicidades.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        required
                        name="fechaFin"
                        label="Fecha Fin"
                        fullWidth
                        type="date"
                        // La periodicidad propone la fecha fin, pero se puede
                        // corregir a mano si el periodo no coincide con ella.
                        onChange={(event) => {
                            dispatch(setData({name: "fechaFin", value: event.target.value}))

                            recalculaDiasLaborables(moment(entity.fechaInicio).format('yyyy-MM-DD'), event.target.value)
                        }}
                        value={moment(entity.fechaFin).format('yyyy-MM-DD')}
                        error={validate.fechaFin && validation.fechaFin.error}
                        helperText={validate.fechaFin && validation.fechaFin.error
                            ? validation.fechaFin.message
                            : "La propone la periodicidad"}
                        disabled={isReadOnly}
                            size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <TextField
                        name="diasLaborables"
                        label="Dias Laborables"
                        fullWidth
                        type="number"
                        value={diasLaborables}
                        disabled
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        helperText={"Sin domingos ni feriados no laborables"}
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    {/* <FormControl required fullWidth error={validate.idEstado && validation.idEstado.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-estadoapertura">Estado Apertura</InputLabel>
                        <Select
                            native
                            label="Estado Apertura"
                            value={entity.idEstadoApertura}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idEstadoApertura',
                                id: 'input-estadoapertura',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstadosApertura.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate.idEstado && validation.idEstado.error ? validation.idEstado.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        name="observaciones"
                        label="Observaciones"
                        fullWidth
                        value={entity.observaciones}
                        onChange={setDataEntity}
                        disabled={isReadOnly}
                            size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="input-categoria">Categoria</InputLabel>
                        <Select
                            native
                            label="Categoria"
                            value={entity.idCategoria}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idCategoria',
                                id: 'input-categoria',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listCategorias.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>
                            {validate.DNIWith8Digits && validation.DNIWith8Digits.error ? validation.DNIWith8Digits.message : ""}
                        </HelperText>
                        <HelperText>
                            {validate.AnyDocumentAtLeast3Digits && validation.AnyDocumentAtLeast3Digits.error ? validation.AnyDocumentAtLeast3Digits.message : ""}
                        </HelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={6} sm={3}>
                    {/* <FormControl required fullWidth error={validate.idEstado && validation.idEstado.error}> */}
                    <FormControl required fullWidth>
                        <InputLabel htmlFor="input-estado">Estado</InputLabel>
                        <Select
                            native
                            label="Estado"
                            value={entity.idEstado}
                            onChange={setDataEntity}
                            inputProps={{
                                name: 'idEstado',
                                id: 'input-estado',
                            }}
                            disabled={isReadOnly}
                            size="small"
                        >
                            <option key={0} value={0}>{"(Seleccione)"}</option>
                            {listEstados.map((row) => (
                                <option key={row.id} value={row.id}>{row.descripcion}</option>
                            ))}
                        </Select>
                        {/* <HelperText>{validate.idEstado && validation.idEstado.error ? validation.idEstado.message : ""}</HelperText> */}
                    </FormControl>
                </Grid>
            </Grid>

            {/* Detalle del periodo: tabla con los periodos
                Academicos referenciados. Solo se puede editar
                cuando el periodo ya esta guardado. */}
            {/* Detalle de Periodos Academicos ocultado */}
            {false && (
            <Grid item xs={12} sm={12} sx={{ marginTop: "16px" }}>
                <Card variant="outlined">
                    <CardContent sx={{ padding: "10px 10px 10px 10px !important" }}>
                        <Box sx={{ fontWeight: 'bold' }} padding={0}>
                            <Typography variant="h7">
                                Detalle de Periodos Academicos
                            </Typography>
                        </Box>

                        {/* Selector de periodos Academicos disponibles para referenciar
                            y su boton Agregar, debajo del titulo. Solo elige; el alta
                            la hace el boton. */}
                        <Grid container alignItems={"center"} spacing={1} sx={{ marginTop: "8px" }}>
                            <Grid item xs={12} sm={4}>
                                <FormControl size="small" fullWidth disabled={isReadOnly}>
                                    <InputLabel htmlFor="input-periodo-academico">Periodo Academico</InputLabel>
                                    <Select
                                        native
                                        label="Periodo Academico"
                                        value={periodoDetalleElegido}
                                        onChange={(event) => setPeriodoDetalleElegido(event.target.value)}
                                        inputProps={{
                                            name: 'idPeriodoDetalleElegido',
                                            id: 'input-periodo-academico',
                                        }}
                                        disabled={isReadOnly}
                                        sx={{ minWidth: "180px" }}
                                    >
                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                        {(listPeriodosAcademicos || [])
                                            .filter((row) => !periodosEnDetalle.includes(row.id))
                                            .map((row) => (
                                                <option key={row.id} value={row.id}>{row.codigo}</option>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    size="small"
                                    disabled={isReadOnly || parseInt(periodoDetalleElegido || "0") <= 0}
                                    startIcon={<IconAddCircle />}
                                    onClick={() => {
                                        const id = parseInt(periodoDetalleElegido || "0");

                                        if (id > 0) {
                                            agregarPeriodoDetalle(id);
                                            setPeriodoDetalleElegido(0);
                                        }
                                    }}
                                >
                                    Agregar
                                </Button>
                            </Grid>
                        </Grid>

                        <TableContainer component={Paper} variant="outlined" sx={{ marginTop: "12px" }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: "#1976d2" }}>
                                        <TableCell sx={{ color: "white" }}>Codigo</TableCell>
                                        <TableCell sx={{ color: "white" }}>Fecha Inicio</TableCell>
                                        <TableCell sx={{ color: "white" }}>Fecha Fin</TableCell>
                                        <TableCell sx={{ color: "white", width: "80px" }} align="center">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(listPeriodoDetalle || []).map((row, index) => (
                                        <TableRow key={row.id && row.id > 0 ? row.id : `detalle-${row.idPeriodoDetalleRef || index}`}>
                                            <TableCell>{row.codigoPeriodoDetalle || ""}</TableCell>
                                            <TableCell>
                                                {row.fechaInicioPeriodoDetalle
                                                    ? moment(row.fechaInicioPeriodoDetalle).format('D/MM/YYYY')
                                                    : ""}
                                            </TableCell>
                                            <TableCell>
                                                {row.fechaFinPeriodoDetalle
                                                    ? moment(row.fechaFinPeriodoDetalle).format('D/MM/YYYY')
                                                    : ""}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Tooltip title={"Quitar periodo"}>
                                                    <span>
                                                        <IconButton aria-label={"quitar periodo"} size="small"
                                                            disabled={isReadOnly}
                                                            onClick={() => quitarPeriodoDetalle(row.id)}>
                                                            <IconDelete fontSize="small" />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    {(listPeriodoDetalle || []).length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">
                                                {"No hay periodos Academicos referenciados"}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            </Grid>
            )}
        </Grid>
            <Snackbar
                open={mensaje != null}
                autoHideDuration={5000}
                onClose={cerrarMensaje}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity="warning" variant="filled" onClose={cerrarMensaje}>
                    {mensaje}
                </Alert>
            </Snackbar>
        </>
    );
}
export default Period;
